<div class="image-generation">
  <div class="image-generation_left">
    <div class="image-generation_header">
      <p>Generate images</p>
      <stxt-button
        [buttonConfig]="galleryButtonConfig"
        (click)="toggleRightPanel()"
        (keydown.enter)="toggleRightPanel()"
        class="gallery-button"
      >
        <stxt-svg-icon [iconConfig]="imageGalleryIcon" class="gallery-button_svg"></stxt-svg-icon>
        <p>My images</p>
      </stxt-button>
    </div>
    <div class="image-generation_left__content">
      <h4 class="left-content_header">Who would you like to create with?</h4>
      <div class="left-content_carousel">
        <stxt-creators-carousel
          [creators]="creators"
          [selectedCreator]="selectedCreator"
          (selectCreatorEvent)="updateSelectedCreator($event)"
        ></stxt-creators-carousel>
      </div>
      <h4 class="left-content_subheader">What would you like to create?</h4>
      <div
        stxtClickOutside
        (clickOutside)="isShowSuggestions = false"
        class="left-content_input relative"
      >
        <div
          [@fade]
          *ngIf="filteredPrompts?.length && isShowSuggestions"
          class="image-generation_prompts absolute w-full"
        >
          <div *ngFor="let suggestedItem of filteredPrompts?.slice(0, 2)">
            <stxt-suggested-prompt
              [suggestedPrompt]="suggestedItem"
              [usageCase]="EPromptUsage.ImageGeneration"
              [userInput]="userInput"
              (click)="selectPrompt(suggestedItem)"
              (keydown.enter)="selectPrompt(suggestedItem)"
            ></stxt-suggested-prompt>
          </div>
        </div>
        <textarea
          #textarea
          [(ngModel)]="userInput"
          (input)="onInputChange(textarea.value)"
          (focus)="isShowSuggestions = true"
          placeholder="Type what you'd like to see or select ideas to help you describe what you'd like"
          class="image-generation_textarea"
        ></textarea>
      </div>

      <div class="left-content_suggestions">
        <stxt-image-presets
          #presets
          (selectedPresetPrompt)="onPresetPrompt($event)"
        ></stxt-image-presets>
      </div>
    </div>

    <div class="image-generation_left__footer">
      <div class="footer-info">
        <img
          *ngIf="selectedCreator?.image"
          [src]="selectedCreator?.image"
          alt="creator"
          class="footer-info_img"
        />
        <div class="footer-info_text">
          <p>Create with {{ selectedCreator?.name }}</p>
          <div class="footer-info_text__token">
            <stxt-svg-icon [iconConfig]="tokenIcon" class="token-icon"></stxt-svg-icon>
            <p
              ngbTooltip="Ten tokens"
              placement="top"
              tooltipClass="custom-tooltip"
              class="cursor-default"
            >
              {{ generatePrice }} tokens
            </p>
            <span>• 1 image</span>
          </div>
        </div>
      </div>
      <stxt-button
        [buttonConfig]="generateButton"
        [disabled]="!userInput.length || isGeneratingImage"
        (click)="generateImage()"
        (keydown.enter)="generateImage()"
        class="generate-button"
      >
        {{ isGeneratingImage ? 'Generating' : generateButton.text }}
      </stxt-button>
    </div>
  </div>
  <div
    [ngClass]="{ 'image-generation_right__visible': isRightPanelVisible }"
    class="image-generation_right"
  >
    <div class="image-generation_header">
      <div class="flex items-center">
        <button (click)="toggleRightPanel()" class="btn-nostyle arrow-icon_wrapper">
          <stxt-svg-icon class="arrow-icon" [iconConfig]="arrowIcon"></stxt-svg-icon>
        </button>
        <p>My images</p>
      </div>
      <div class="image-generation_filters flex relative">
        <ng-container *ngIf="isJustAddedEnabled && imagesToDisplay.length > 0">
          <button
            [ngClass]="{ 'image-generation_filters__active': activeFilter === EMediaFilter.All }"
            (click)="selectFilter(EMediaFilter.All)"
            class="button-wrapper image-generation_filters__btn btn-nostyle"
          >
            All
          </button>
          <button
            [ngClass]="{
              'image-generation_filters__active': activeFilter === EMediaFilter.JustAdded
            }"
            (click)="selectFilter(EMediaFilter.JustAdded)"
            class="button-wrapper image-generation_filters__btn btn-nostyle"
          >
            Just added
          </button>
        </ng-container>
        <button
          *ngIf="availableCreatorsFilters.length"
          [ngClass]="{ 'filter-active': isShowFilter }"
          class="button-wrapper btn-nostyle"
        >
          <stxt-svg-icon
            [iconConfig]="filterIcon"
            (click)="showFilters($event)"
            (keydown.enter)="showFilters($event)"
          ></stxt-svg-icon>
        </button>
        <div
          *ngIf="isShowFilter"
          stxtClickOutside
          (clickOutside)="isShowFilter = false"
          class="image-generation_filter absolute"
        >
          <ng-container *ngFor="let creator of availableCreatorsFilters">
            <div
              (click)="filterImagesByCreator(creator, $event)"
              (keydown.enter)="filterImagesByCreator(creator, $event)"
              tabindex="0"
              class="image-generation_filter__creator flex items-center"
            >
              <div [class.checked]="isChecked(creator.id)" class="custom-checkbox">
                <svg *ngIf="isChecked(creator.id)" viewBox="0 0 24 24" class="check-icon">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
                </svg>
              </div>
              <p>{{ creator?.name }}</p>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="image-generation_right__content">
      <ng-container *ngIf="activeFilter === EMediaFilter.All">
        <div class="generated-images">
          <div
            *ngFor="let image of imagesToDisplay; let i = index"
            class="generated-images_item__wrapper protected-generated-image"
          >
            <ng-container *ngIf="!image.isError">
              <stxt-thumbnail-loader
                *ngIf="image.url.length === 0"
                [generationId]="image.id"
                class="generating_loader"
              ></stxt-thumbnail-loader>
              <stxt-image
                *ngIf="image.url && image.url.length > 0"
                [src]="image.url"
                [alt]="'Generated image'"
                [mediaUsage]="EImageUsage.Gallery"
                (click)="openMediaFullScreen(image)"
                (keydown.enter)="openMediaFullScreen(image)"
              ></stxt-image>
            </ng-container>
          </div>
        </div>
        <ng-container *ngIf="!imagesToDisplay.length">
          <ng-container *ngTemplateOutlet="emptyState"></ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="activeFilter === EMediaFilter.JustAdded">
        <div *ngIf="justAddedImages?.length > 0" class="just-generated_wrapper">
          <ng-container
            *ngIf="
              justAddedImages?.length > 0 &&
              !(justAddedImages.length === 1 && selectedJustAddedMedia?.url.length === 0)
            "
          >
            <div *ngFor="let image of justAddedImages">
              <div
                *ngIf="!image.isError"
                [ngClass]="{
                  'just-generated_thumbnail--active': selectedJustAddedMedia?.id === image.id,
                  'just-generated_thumbnail--pending': !image.url
                }"
                [style.backgroundImage]="
                  selectedJustAddedMedia?.id !== image.id && image.url
                    ? 'url(' + image.url + ')'
                    : 'none'
                "
                (click)="selectImage(image)"
                (keydown)="selectImage(image, $event)"
                tabindex="-1"
                class="just-generated_thumbnail"
              >
                <img
                  *ngIf="selectedJustAddedMedia?.id === image.id && image.url"
                  [src]="image.url"
                  alt="thumbnail"
                  class="just-generated_thumbnail__img"
                />
              </div>
            </div>
          </ng-container>
        </div>
        <div *ngIf="justAddedImages?.length > 0" class="just-generated_image__wrapper">
          <stxt-image
            *ngIf="selectedJustAddedMedia?.url?.length > 0 && !selectedJustAddedMedia?.isError"
            [src]="selectedJustAddedMedia.url"
            [fill]="true"
            [priority]="true"
            [alt]="'Selected generated image'"
            [mediaUsage]="EImageUsage.Gallery"
            (click)="openMediaFullScreen(selectedJustAddedMedia)"
            (keydown.enter)="openMediaFullScreen(selectedJustAddedMedia)"
            class="just-generated_image__item"
          ></stxt-image>

          <stxt-thumbnail-loader
            *ngIf="selectedJustAddedMedia?.url?.length === 0"
            [generationId]="selectedJustAddedMedia.id"
            class="generating_loader"
          ></stxt-thumbnail-loader>
        </div>
        <ng-container *ngIf="justAddedImages.length === 0">
          <ng-container *ngTemplateOutlet="emptyState"></ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="isToastMessage">
        <stxt-toast
          [toast]="toast"
          (closeToast)="isToastMessage = false"
          class="fixed-toast"
        ></stxt-toast>
      </ng-container>
    </div>
  </div>
</div>

<ng-container *ngIf="mediaFullScreen">
  <stxt-media-lightbox
    [generatedMediaList]="imagesToDisplay"
    [selectedGeneratedMedia]="selectedMedia"
    [usageCase]="EMediaLightboxUsage.ImageGeneration"
    [creators]="creators"
    (closeFullScreen)="mediaFullScreen = false"
    [postDescription]="postDescription"
    (regenerateImage)="openRegenerateModal($event)"
    class="image-generation_lightbox"
  ></stxt-media-lightbox>
</ng-container>

<ng-template #emptyState>
  <div class="no-images_wrapper">
    <stxt-empty-state
      [emptyStateData]="emptyStateData"
      (emptyStateButtonClicked)="isRightPanelVisible = false"
      class="no-images_empty-state"
    ></stxt-empty-state>
  </div>
</ng-template>
